import { emailConfirmation } from '@/api/email-confirmation'

export type ApiResult<T> = {
  data: T | null
  success: boolean
  error?: string
}

const getAxiosErrorText = (error: unknown, fallback: string): string => {
  const data = (error as any)?.response?.data
  if (typeof data?.message === 'string' && data.message.trim()) {
    return data.message
  }
  if (typeof data?.error === 'string' && data.error.trim()) {
    return data.error
  }
  if (error instanceof Error && error.message.trim()) {
    return error.message
  }
  return fallback
}

/** POST /v1/verification/send-email-code — сырой `{ success, error? }` */
export const sendEmailCode = async (
  userId: number,
  email: string,
): Promise<ApiResult<boolean>> => {
  try {
    const res = await emailConfirmation.sendEmailCode({
      user_id: userId,
      email,
    })
    const payload = res?.data
    const success = payload?.success === true

    return {
      data: success,
      success,
      error:
        (typeof payload?.error === 'string' && payload.error) ||
        (typeof payload?.message === 'string' && payload.message) ||
        'Неизвестная ошибка',
    }
  } catch (error) {
    return {
      data: null,
      success: false,
      error: getAxiosErrorText(error, 'Не удалось отправить код'),
    }
  }
}

/** POST /v1/verification/verify-email-code */
export const verifyEmailCode = async (
  userId: number,
  code: string,
): Promise<ApiResult<{ message?: string }>> => {
  try {
    const res = await emailConfirmation.verifyEmailCode({
      user_id: userId,
      code,
    })
    const payload = res?.data
    const success =
      payload?.success === true ||
      payload?.status === 'success' ||
      res?.status === 200

    return {
      data: payload?.data ?? payload,
      success,
      error:
        (typeof payload?.error === 'string' && payload.error) ||
        (typeof payload?.message === 'string' && payload.message) ||
        undefined,
    }
  } catch (error) {
    return {
      data: null,
      success: false,
      error: getAxiosErrorText(
        error,
        'Неверный код или срок действия истёк',
      ),
    }
  }
}

/** GET /v1/verification/get-email-status?user_id= */
export const getEmailStatus = async (
  userId: number,
): Promise<
  ApiResult<{ email?: string; isEmailConfirmed?: boolean; hasEmail?: boolean }>
> => {
  try {
    const res = await emailConfirmation.getEmailStatus(userId)
    const payload = res?.data?.data ?? res?.data
    return {
      data: payload,
      success: true,
    }
  } catch (error) {
    return {
      data: null,
      success: false,
      error: getAxiosErrorText(error, 'Не удалось получить статус почты'),
    }
  }
}
